export default {
  rights:{
    title:'Benutzer Rechte',
    ACCOUNT:"Account",
    ACCOUNTING:"Buchhaltung",
    COLOCATION:"Colocation",
    DOMAINS:"Domains",
    MISC:"Sonstiges",
    SSL_CERTIFICATES:'SSL Zertifikate',
    SUPPORT:'Support',
    VSERVER:'Vserver',
    select_all:'Alle auswählen',
    all_selected:'Alle ausgewählt'
  },
  users:{
    title:'Benutzer Daten',
    id:'ID',
    username:'Benutzer',
    actions:'Aktionen',
    email:'E-Mail',
    firstname:'Vorname',
    lastname:'Nachname',
    password:'Passwort',
    password_confirm:'Passwort wiederholen',
    password_hint:'Passwörter checken & Minimum 8 Zeichen',
    password_valid:'Speichern'
  }
}



// WEBPACK FOOTER //
// ./src/lang/de/account.js